import { Box } from "@mui/material";
import type { FC } from "react";

export const EmailMobilePreview: FC<{ data: string }> = ({ data }) => {
  const mobileOptimizedData = data.replace(
    "</head>",
    `<style>
    .header, .paper, .footer { 
      width: 100% !important; 
      max-width: 100% !important; 
    }
    table { width: 100% !important; }
  </style></head>`,
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        bgcolor: "#f5f5f5", // Neutral background to see the "phone" edges
        height: "100%",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "375px",
          height: "100%",
          boxShadow: "0 0 20px rgba(0,0,0,0.2)",
          overflow: "hidden",
          bgcolor: "white",
        }}
      >
        <iframe
          sandbox="allow-popups allow-popups-to-escape-sandbox"
          srcDoc={mobileOptimizedData}
          style={{ width: "100%", height: "100%" }}
          title="ChangeEngine Email Preview"
          role="document"
          data-testid="preview-email-iframe"
        />
      </Box>
    </Box>
  );
};
